var splice = require('./splice');

module.exports = function insert(str, i, substr) {
  return splice(str, i, 0, substr);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/insert.js
// module id = 2268
// module chunks = 0